const React = require('react');
const AdminFeeTable = require('../../../../../../../dumb/AdminHelpers/AdminFeeTable');
const withState = require('../../../../../../../../utils/withState');
const {
  apiAdminMerchantRetailerFeesGet,
  apiAdminMerchantRetailerFeesUpdate,
  apiAdminMerchantRetailerFeesReset
} = require("../../../../../../../../api/admin/retailers");
const FeeInput = require("../../../../../../../dumb/AdminHelpers/AdminFeeTable/components/FeeInput");

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    loading: true
  };

  const onSubmit = ({payload, confirmBearer}) => (
    apiAdminMerchantRetailerFeesUpdate({
      merchant_id: self.props.userId,
      payload,
      confirmBearer
    })
  );

  const onResult = () => {
    setState({isGlobal: false});
  }

  const onGlobalClick = (confirmBearer) => {
    setState({loading: true});

    const merchant_id = self.props.userId;
    return apiAdminMerchantRetailerFeesReset({merchant_id, confirmBearer})
        .then(() => apiAdminMerchantRetailerFeesGet({merchant_id}))
        .then((res) => setState({list: res.list || [], isGlobal: true}))
        .finally(() => setState({loading: false}))
  }

  onMount(() => {
    const merchant_id = self.props.userId;

    apiAdminMerchantRetailerFeesGet({merchant_id})
      .then((res = {}) => {
        const list = res.list || [];
        list.every((el) => {
          return el.merchant_id === '00000000-0000-0000-0000-000000000000'
        })
        return (
          setState({
            list,
            isGlobal: list.every((el) => el.merchant_id === '00000000-0000-0000-0000-000000000000'),
            loading: false
          })
        )
      });
  });

  const disableField = (payment_method) => !['upi', 'upiQrCode', 'netbanking'].includes(payment_method)

  return ({loading, list, isGlobal}) => {
    return loading
      ? (
        <span />
      ) : (
        <div className="mt53">
          <AdminFeeTable
            items={list}
            minWidth={1250}
            maxHeight={window.innerHeight - 575}
            onSubmit={onSubmit}
            onResult={onResult}
            additionalColsCtor={(formCtx) => [
              {
                title: 'Tax',
                className: 'w125 pv0-i ph11-i',
                handleCol: ({payment_method}) => (
                  <FeeInput
                    name={`${payment_method}_tax`}
                    formCtx={formCtx}
                    disabled={disableField(payment_method)}
                    symbol={`₹ <br /> %`}
                  />
                ),
              },
              {
                title: 'Rolling Reserve',
                className: 'w125 pv0-i ph11-i',
                handleCol: ({payment_method}) => (
                  <FeeInput
                    name={`${payment_method}_rolling_reserve`}
                    formCtx={formCtx}
                    disabled={disableField(payment_method)}
                    symbol={`₹ <br /> %`}
                  />
                ),
              },
            ]}
            onGlobalClick={onGlobalClick}
            disabledGlobal={isGlobal}
          />
        </div>
      )
  }
});
